"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Returns true when code is running in server mode
function isServer() {
  return typeof window === 'undefined';
}

var _default = isServer;
exports["default"] = _default;